import React, { useState } from 'react';
import { Select, MenuItem, TextField, FormControl } from '@mui/material';
import { useDispatch } from "react-redux";
import { setState } from "../analyzeSlice";

const SingleSelectConsumptionFilter = (props) => {
  const [selectedOption, setSelectedOption] = useState('');
  const [numberValue, setNumberValue] = useState('');
  const dispatch = useDispatch();

  const columnData = props?.getSKUData;
  const columns = [
    ...new Set(columnData.map((item) => item.skuName)),
  ];  

  const handleSelectChange = (event) => {
    debugger;
    if(event.target.value === "") {
      dispatch(setState("selectedConsValFilter", ""));
      setNumberValue("");
    }
    setSelectedOption(event.target.value);
    dispatch(setState("selectedOprConsFilter", event.target.value));
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) { // This regex allows only numbers
      setNumberValue(value);
      dispatch(setState("selectedConsValFilter", value));
    }
  };

  const handleClick = (event) => {
    event.stopPropagation(); // Prevent sorting when select or textbox is clicked
  };

  return (
    
    <div style={{ display: 'flex', alignItems: 'center' }}>
        {columns.length > 0 && (
        <div>
      <FormControl
        sx={{
            "&.MuiFormControl-root": {
              width: "auto !important", // Override the width to auto
            },
          }}      
      >
        <Select
          labelId="select-label"
          value={selectedOption}
          onChange={handleSelectChange}
          onClick={handleClick}
          sx={{
            "&.MuiFormControl-root":{
                minWidth: "50px !important",
                width: "50% !important",
                height: "38px !important",
            },
            "&.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl": {
              minWidth: "50px !important",
              width: "50% !important",
              height: "38px !important",
            },
            mt: "-10px !important",
          }}
          size="small"
        >
          <MenuItem value="" sx={{ height: '38px' }}></MenuItem>
          <MenuItem value="=" sx={{ minHeight: '38px' }}>=</MenuItem>
          <MenuItem value="&gt;" sx={{ minHeight: '38px' }}>&gt;</MenuItem>
          <MenuItem value="&lt;" sx={{ minHeight: '38px' }}>&lt;</MenuItem>
          <MenuItem value="&gt;=" sx={{ minHeight: '38px' }}>&gt;=</MenuItem>
          <MenuItem value="&lt;=" sx={{ minHeight: '38px' }}>&lt;=</MenuItem>
        </Select>
        </FormControl>      
        <TextField
          value={numberValue}
          onChange={handleInputChange}
          onClick={handleClick}
          sx={{
            "& .MuiInputBase-root": {
              minWidth: "70px !important",
              width: "70% !important",
              height: "38px !important",
            },
            "& .MuiOutlinedInput-root": {
              padding: "0px !important",
            },
            "& .MuiInputBase-input": {
              padding: "8px 14px !important",
              height: "20px !important", 
              width: "50% !important",
            },
            "&.MuiFormControl-root":{
                width: "50% !important",
            },
            height: "38px !important",
            mt: "-10px !important",
          }}
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        />
        </div>
        )}
    </div>
  );
};

export default SingleSelectConsumptionFilter;